import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  // 平安入金白名单列表
  getPinganWhiteList(data) {
    return request.get(`${BASE_URL}/pingan/list`, data)
  },
  // 创建
  createPinganWhite(data){
    return request.post(`${BASE_URL}/pingan/add`, data)
  },
  // 删除
  deletePinganWhite(data){
    return request.post(`${BASE_URL}/pingan/delete`,data)
  }
}